// extracted by mini-css-extract-plugin
export default {"clock_in_out_buttons":"QRForm_clock_in_out_buttons__IreZJ","active":"QRForm_active__22xr6"};